<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择客户"
      width="1200px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="customers"
        @select="selectCustomer"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="关键字" prop="filter">
            <el-input v-model.trim="filter.filter" placeholder="请输入关键字" clearable/>
          </el-form-item>
        </el-form>
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="客户名称" prop="filter">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-form>
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="客户编号" prop="filter">
            <el-input v-model.trim="filter.customerNo" placeholder="请输入客户编号" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          filter: "",
          customerName:"",
          customerNo:"",
        },
        columns: [
          {
            title: "客户编号",
            key: "outerNo",
            width: 100,
            align: "center",
          },
          {
            title: "客户名称",
            key: "customerName",
          },
          {
            title: "联系人",
            key: "contact",
            width: 100,
            align: "center",
          },
          {
            title: "联系方式",
            key: "telephone",
            width: 130,
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "left",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectCustomer(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
